export default "__VITE_ASSET__66a36963__"